const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    month: month.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    year: year.replace(/\D/g, "").slice(0, 4),
  };
};

const fmtQty = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "";
  if (Math.abs(num - Math.trunc(num)) < 0.000001) return `${Math.trunc(num)}`;
  return num.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

export const getPrintTemplate = ({ headerInfo, rows, totals }) => {
  const date = splitDate(headerInfo.documentDate);

  const rowsHtml = (rows || [])
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.itemName || "")}</td>
        <td class="center">${escapeHtml(row.itemCode || "")}</td>
        <td class="center">${escapeHtml(row.unit || "")}</td>
        <td class="right">${fmtQty(row.totalQuantity)}</td>
        <td class="right">${fmtQty(row.quantityRemainForUse)}</td>
        <td class="right">${fmtQty(row.quantityReturnedToStock)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Bảng Kê Chi Tiết Vật Tư Còn Lại Cuối Kỳ</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:29px; font-weight:700; text-transform:uppercase; }
        .date-line { text-align:center; margin-top:8px; font-style:italic; }
        .meta-right { text-align:right; margin-top:8px; line-height:1.5; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:14px; }
        th, td { border:1px solid #000; padding:4px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signature { margin-top:22px; display:flex; justify-content:flex-end; text-align:center; }
        .signature .box { width:34%; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 04 - VT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BẢNG KÊ CHI TIẾT VẬT TƯ CÒN LẠI CUỐI KỲ</div>
      <div class="date-line">Ngày ${date.day || "..."} tháng ${date.month || "..."} năm ${date.year || "...."}</div>

      <div class="meta-right">
        <div>Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>
      </div>

      <div style="margin-top:6px;"><b>Bộ phận sử dụng:</b> ${escapeHtml(headerInfo.usageDepartment || "")}</div>

      <table>
        <thead>
          <tr>
            <th rowspan="2" style="width:7%">Số TT</th>
            <th rowspan="2" style="width:35%">Tên, nhãn hiệu, quy cách, phẩm chất vật tư</th>
            <th rowspan="2" style="width:12%">Mã số</th>
            <th rowspan="2" style="width:12%">Đơn vị tính</th>
            <th colspan="3" style="width:34%">Số lượng</th>
          </tr>
          <tr>
            <th>Tổng</th>
            <th>Để lại sử dụng</th>
            <th>Nhập lại kho</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>C</th><th>D</th><th>1</th><th>2</th><th>3</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="4" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtQty(totals.totalQuantity)}</b></td>
            <td class="right"><b>${fmtQty(totals.quantityRemainForUse)}</b></td>
            <td class="right"><b>${fmtQty(totals.quantityReturnedToStock)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signature">
        <div class="box">
          <div><b>Phụ trách bộ phận sử dụng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
